/**
 * Função de debounce que irá criar um timeout do tempo passado por parâmetro, para então executar a função passada por parâmetro
 * @param fn Função que vai ser executada;
 * @param ms Tempo de espera para executar a função;
 */
export function debounce<A = unknown, R = void>(fn: (args: A) => R, ms = 0) {
	let timeoutId: NodeJS.Timeout;
	return function (this: unknown, args: A) {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => fn.apply(this, [args]), ms);
	};
}
